var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C16 32 27 20.0751 27 11C27 4.92487 22.0751 0 16 0C9.92487 0 5 4.92487 5 11C5 20.0751 16 32 16 32ZM15.9998 16C18.7612 16 20.9998 13.7614 20.9998 11C20.9998 8.2386 18.7612 6.00002 15.9998 6.00002C13.2383 6.00002 10.9998 8.2386 10.9998 11C10.9998 13.7614 13.2383 16 15.9998 16Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;